import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { THEFT_REGISTRIES_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const cancelTheftRegistryAction = createAsyncThunk(
    'order/cancelTheftRegistryAction',
    async (id, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.delete(`${ THEFT_REGISTRIES_PATH }/${ id }`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const cancelTheftRegistrySlice = createSlice({
    name: 'cancelTheftRegistrySlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(cancelTheftRegistryAction.pending, () => STATE__API__STARTED);
        builder.addCase(cancelTheftRegistryAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(cancelTheftRegistryAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const cancelTheftRegistryState = (state) => state.order.cancelTheftRegistry;
export default cancelTheftRegistrySlice.reducer;
